<template>
  <el-card class="Person-container" style="width: 500px;">
    <el-form label-width="120px" size="small">
      <!--头像-->
      <el-upload
          name="multipartFile"
          class="avatar-uploader"
          :action="'https://'+WHITE_IP+'/document/upload'"
          :show-file-list="false"
          :on-success="onSuccess">
        <!--头像是从Composite接受的user-->
        <img v-if="userForm.avatar" :src="userForm.avatar" class="avatar" style="border-radius: 4px;">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>

      <el-form-item label="用户名">
        <el-input v-model="userForm.name" disabled autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="角色">
        <el-input v-model="userForm.role" disabled autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="昵称">
        <el-input v-model="userForm.nick" autocomplete="off"></el-input>
      </el-form-item>
      <!--      <el-form-item label="邮箱">
              <el-input v-model="userForm.email" autocomplete="off"></el-input>
            </el-form-item>-->
      <el-form-item label="手机">
        <el-input v-model="userForm.phone" autocomplete="off"
                  placeholder="填写手机号，方便系统出现问题及时告知您"></el-input>
      </el-form-item>
      <!--      <el-form-item label="地址">
              <el-input type="textarea" v-model="userForm.address" autocomplete="off"></el-input>
            </el-form-item>-->

      <el-form-item>
        <el-button type="primary" @click="insertOrUpdate">确 定</el-button>
        <el-button type="warning" @click="$router.back()">返 回</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
import {WHITE_IP} from "../../../public/config"; // 引入动态IP地址
export default {
  name: "Person",
  data() {
    return {
      WHITE_IP: WHITE_IP,
      userForm: {},
      // 从本地存储拿赋值给user
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}
    }
  },
  created() {
    this.$http.post("/user/select", this.user).then(res => {
      if (res.data.code === "200") {
        this.userForm = res.data.object;
      } else {
        this.$message.error("获取个人信息失败" + res.data.message)
      }
    })
  },
  methods: {
    /*上传头像成功*/
    onSuccess(res) {
      this.userForm.avatar = res
    },
    /*更新或修改*/
    insertOrUpdate() {
      this.userFormFlag = false
      this.$http.post("/user/insertOrUpdate", this.userForm).then(res => {
        if (res.data.code === "200") {
          this.$message.success('保存成功')
          // 触发父级更新user方法
          this.$emit("person_fff_user", this.user)
        } else {
          this.$message.error('保存失败，' + res.data.message)
        }
      })
    },
  }
}
</script>

<style scoped>
.avatar-uploader {
  text-align: center;
  padding-bottom: 10px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 138px;
  height: 138px;
  line-height: 138px;
  text-align: center;
}

.avatar {
  width: 138px;
  height: 138px;
  display: block;
}
</style>
